<div class="modal-content">
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title">
      {{ "APPEAL_ELIGIBILITY_POPUP_HEADER" | globalTranslate }}
    </h1>
    <button
      type="button"
      class="btn-close pull-right"
      [attr.aria-label]="'CLOSE' | globalTranslate"
      (click)="onCancel()"
    >
      <img src="../../assets/images/⚛️ icons-close-circle-outline.svg" />
    </button>
  </div>
  <div class="modal-body">
    @if (appealEligibilityTypeRows && appealEligibilityTypeRows.length) {
    <div>
      <div class="d-none d-lg-block">
        @if (!isMobileView) {
        <ngx-datatable
          class="bootstrap striped"
          #table
          [rows]="appealEligibilityTypeRows"
          [columnMode]="'force'"
          [headerHeight]="'auto'"
          [footerHeight]="50"
          [rowHeight]="'auto'"
        >
          <ngx-datatable-column
            [name]="'APPEAL_ELIGIBILITY_TYPE' | globalTranslate"
            [width]="180"
          >
            <ng-template
              ngx-datatable-cell-template
              let-row="row"
              let-rowIndex="rowIndex"
            >
              {{ row.appealType | globalTranslate }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            [name]="'APPEAL_ELIGIBILITY_DESCRIPTION' | globalTranslate"
          >
            <ng-template
              ngx-datatable-cell-template
              let-row="row"
              let-rowIndex="rowIndex"
            >
              {{ row.description | globalTranslate }}
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
        }
      </div>
      <div class="nh-table-mobile d-lg-none">
        <div class="table-row mb-3 pb-3">
          <div class="mobile-table-header">
            {{ "ELIGIBILITY_APPEAL" | globalTranslate }}
          </div>
          <hr />
          <div class="mobile-table-data">
            {{ "ELIGIBILITY_APPEAL_DESCRIPTION" | globalTranslate }}
          </div>
          <br />
          <div class="mobile-table-header">
            {{ "RENEWAL_APPEAL" | globalTranslate }}
          </div>
          <hr />
          <div class="mobile-table-data">
            {{ "RENEWAL_APPEAL_DESCRIPTION" | globalTranslate }}
          </div>
          <br />
          <div class="mobile-table-header">
            {{ "KATIE_BECKETT_APPEAL" | globalTranslate }}
          </div>
          <hr />
          <div class="mobile-table-data">
            {{ "KATIE_BECKETT_APPEAL_DESCRIPTION" | globalTranslate }}
          </div>
          <br />
          <div class="mobile-table-header">
            {{ "LTSS_APPEAL" | globalTranslate }}
          </div>
          <hr />
          <div class="mobile-table-data">
            {{ "LTSS_APPEAL_DESCRIPTION" | globalTranslate }}
          </div>
        </div>
      </div>
    </div>
    }
  </div>
</div>